import React, { Component } from "react";
import { Link } from "gatsby";
import Layout from "./layout";
import "../css/style.css"

class ProgramStrutcureUg extends Component {
  


render(){
  return(

                        <div>
                            <div class="campus-learning-inner">
                                <div class="text-box">
                                    <h3>Stage A: Online Learning </h3>
                                    <p>The online program is brought to you by {this.props.Term1Info}. The online program is designed to develop a solid foundation for your overseas studies and get you accustomed to the university’s academic standards. Each online module takes 7 weeks to complete and you can take upto 2 modules at a time thereby finishing the entire online component within 3.5 months. With our student friendly online focussed curriculum and award winning 1-1 tutor program you will be well on your way to your dream destination. Modules done online are fully recognised for equivalent credit by {this.props.UniversityName}
                                    </p>
                                
                                </div>
                                <div class="campus-learning-box">
                                    {this.props.subjectInfo}
                                    {/* <ul>
                                        <li>
                                            <p><strong>1.</strong>COMM100: Writing and Research for Business & Commerce</p>
                                           
                                        </li>
                                        <li>
                                            <p><strong>2.</strong>ACTG102: Accounting for Business Management</p>
                                           
                                        </li>
                                        <li>
                                            <p><strong>3.</strong>Math102: Introduction to Statistics</p>
                                           
                                        </li>
                                        <li>
                                            <p><strong>4.</strong>BUSS103: Principles of Marketing</p>
                                           
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                            <div class="campus-learning-inner">
                                <div class="text-box">
                                    <h3>Stage B: On Campus Learning (Remainder of Yr 1, Yr 2 and Yr 3)</h3>
                                    <p>Upon completion of the online modules, you will articulate to {this.props.Term2Info} and {this.props.Term3Info} to complete the rest of your education. You will complete the remaining core and elective modules for this program on campus and get your degree. All students who complete the program qualify for post-study work-rights. 
                                    <br/><br/>Further details on the on-campus program structure, courses done at {this.props.Term2Info}, completion requirements and specialisations are available with our admissions team. 
</p>
                                </div> 
                            </div>
                        </div>
  )
}

}

export default ProgramStrutcureUg;